import { AlertType } from '@cbridge-packages/alert';

export enum AlertsDashboardColumnFilterNames {
  type = 'type',
}

export enum AlertsDashboardQuickFilterNames {
  fromTimestamp = 'fromTimestamp',
  toTimestamp = 'toTimestamp',
  excludeSkipped = 'excludeSkipped',
}

export interface IAlertsDashboardFilter {
  type?: AlertType;
  fromTimestamp?: number;
  toTimestamp?: number;
  excludeSkipped?: boolean;
}

export interface ITriggeredAlertsKey extends IAlertsDashboardFilter {
  limit?: number;
  skip?: number;
}

export interface IAlertsDashboardStore {
  filter: IAlertsDashboardFilter;
  nextRequestTimestamp?: number;
  lastUpdatedAt?: number;
  isPollingEnabled?: boolean;
}

export interface IAlertsDashboardStoreSegment {
  alertsDashboard: IAlertsDashboardStore;
}
